/**
 * Anlık aktivite feed / istatistikler — eventType → Türkçe metin (tek kaynak).
 * ActivityFeed, ActivityStatsWidget ve UserDetail bu dosyayı kullanır.
 */

export const EVENT_TYPE_ALIASES = {
  login: 'user_login',
  userlogin: 'user_login',
  app_login: 'user_login',
  sign_in: 'user_login',
  signin: 'user_login',
  user_sign_in: 'user_login',
  user_logout: 'user_logout',
  logout: 'user_logout',
  userlogout: 'user_logout',
  limit_increase_request: 'limit_increase_requested',
  limitincreaserequest: 'limit_increase_requested',
  limitincreaserequested: 'limit_increase_requested',
  limit_increase_confirmed: 'limit_increase_confirmed',
  limitincreaseconfirmed: 'limit_increase_confirmed',
  campaign_detail_view: 'campaign_viewed',
  campaign_view: 'campaign_viewed',
  campaign_impression: 'campaign_viewed',
  campaign_impressions: 'campaign_viewed',
  campaignviewed: 'campaign_viewed',
  campaignview: 'campaign_viewed',
  campaignimpression: 'campaign_viewed',
  campaignimpressions: 'campaign_viewed',
  campaigndetailview: 'campaign_viewed',
  screenview: 'screen_view',
  screen_wiew: 'screen_view',
  sessionstart: 'session_start',
  sessionend: 'session_end',
  sessionUpdate: 'session_update',
  sessionupdate: 'session_update',
  profileUpdate: 'profile_update',
  profileupdate: 'profile_update',
  customerRatingSubmitted: 'customer_rating_submitted',
  customerratingsubmitted: 'customer_rating_submitted',
  fcm_token_registered: 'user_token_registered',
  fcm_token_kaydedildi: 'user_token_registered',
  usertokenregistered: 'user_token_registered',
  usertokenunregistered: 'user_token_unregistered',
  userregister: 'user_register',
  user_registered: 'user_register',
  userconnectionestablished: 'user_connection_established',
  userconnectionclosed: 'user_connection_closed',
  login_failed: 'login_failed',
  loginfailed: 'login_failed',
  failed_login: 'login_failed',
  login_option_click: 'login_option_click',
  loginoptionclick: 'login_option_click',
  payment_modal_open: 'payment_modal_open',
  paymentmodalopen: 'payment_modal_open',
  paymentmethodselected: 'payment_method_selected',
  password_set_success: 'password_set_success',
  passwordsetsuccess: 'password_set_success',
  password_reset_success: 'password_reset_success',
  passwordresetsuccess: 'password_reset_success',
  sms_verification_result: 'sms_verification_result',
  smsverificationresult: 'sms_verification_result',
  sms_verification: 'sms_verification_result',
  smsverification: 'sms_verification_result',
  notification_click: 'notification_click',
  notificationclick: 'notification_click',
  notificationsent: 'notification_sent',
  notificationread: 'notification_read',
  upcoming_installments_view: 'upcoming_installments_view',
  upcominginstallmentsview: 'upcoming_installments_view',
  upcoming_installments_detail_click: 'upcoming_installments_detail_click',
  upcominginstallmentsdetailclick: 'upcoming_installments_detail_click',
  transactions_view_all_click: 'transactions_view_all_click',
  transactionsviewallclick: 'transactions_view_all_click',
  transactions_filter_apply: 'transactions_filter_apply',
  transactionsfilterapply: 'transactions_filter_apply',
  contact_action_click: 'contact_action_click',
  contactactionclick: 'contact_action_click',
  qr_code_generate: 'qr_code_generated',
  qrcodegenerate: 'qr_code_generated',
  qr_code_generated: 'qr_code_generated',
  qrcodegenerated: 'qr_code_generated',
  onboarding_continue_click: 'onboarding_continue_click',
  onboardingcontinueclick: 'onboarding_continue_click',
  onboarding_step_change: 'onboarding_step_change',
  onboardingstepchange: 'onboarding_step_change',
  onboarding_step_view: 'onboarding_step_view',
  onboardingstepview: 'onboarding_step_view',
  onboarding_completed: 'onboarding_completed',
  onboardingcompleted: 'onboarding_completed',
  limit_increase_approved: 'limit_increase_approved',
  limitincreaseapproved: 'limit_increase_approved',
  limit_increase_rejected: 'limit_increase_rejected',
  limitincreaserejected: 'limit_increase_rejected',
  online_payment_started: 'online_payment_started',
  onlinepaymentstarted: 'online_payment_started',
  online_payment_submitted: 'online_payment_submitted',
  onlinepaymentsubmitted: 'online_payment_submitted',
  online_payment_result: 'online_payment_result',
  onlinepaymentresult: 'online_payment_result',
  sms_resend_click: 'sms_resend_click',
  smsresendclick: 'sms_resend_click',
  screendwell: 'screen_dwell',
  dwell: 'screen_dwell',
  emptystateview: 'empty_state_view',
  emptystatepromoview: 'empty_state_promo_view',
  otptimeout: 'otp_timeout',
  otp_time_out: 'otp_timeout',
  qrpromopopupshown: 'qr_promo_popup_shown',
  qrpromopopupdismissed: 'qr_promo_popup_dismissed',
  notificationpermissionresult: 'notification_permission_result',
  supportlinesopen: 'support_lines_open',
  notificationbellclick: 'notification_bell_click',
  webshoppingclosed: 'web_shopping_closed',
  webshoppingopened: 'web_shopping_opened',
  pulltorefresh: 'pull_to_refresh',
  locationpermissionresult: 'location_permission_result',
  onlinepayment3dsshown: 'online_payment_3ds_shown',
  paymentcontractaccepted: 'payment_contract_accepted',
  onlinepayment3dsresult: 'online_payment_3ds_result',
  limitincreaseoffer: 'limit_increase_offer',
  paymentresulthomeclick: 'payment_result_home_click',
  passwordvisibilitytoggle: 'password_visibility_toggle',
  faqopen: 'faq_open',
  notificationdeleted: 'notification_deleted',
  passwordsetattempt: 'password_set_attempt',
  customamountopen: 'custom_amount_open',
  limitincreaseconfirm: 'limit_increase_confirm',
  limitincreaseresult: 'limit_increase_result',
  transactionsfilteropen: 'transactions_filter_open',
  receiptdownloadclick: 'receipt_download_click',
  emptystatepromoclick: 'empty_state_promo_click',
  notificationsdeleteallconfirm: 'notifications_delete_all_confirm',
  notificationsdeleteallopen: 'notifications_delete_all_open',
  notificationsmarkallread: 'notifications_mark_all_read',
  formvalidationerror: 'form_validation_error',
  upcomingpaymentsshowallclick: 'upcoming_payments_show_all_click',
  onlinepaymentinstallmentselected: 'online_payment_installment_selected',
  loginattempt: 'login_attempt',
};

/** Kullanıcı adı olmadan, cümle gövdesi (küçük harf fiil) — feed satırları */
export const ACTIVITY_EVENT_PHRASES = {
  user_token_registered: 'FCM token kaydetti',
  user_token_unregistered: 'FCM token kaldırdı',
  user_register: 'uygulamaya kayıt oldu',
  user_registered: 'uygulamaya kayıt oldu',
  user_login: 'uygulamaya giriş yaptı',
  login_option_click: 'giriş seçeneğine tıkladı',
  user_logout: 'uygulamadan çıkış yaptı',
  user_connection_established: 'WebSocket bağlantısı kurdu',
  user_connection_closed: 'WebSocket bağlantısını kapattı',
  notification_sent: 'bildirim gönderdi',
  notification_read: 'bildirimi okudu',
  notification_click: 'bildirime tıkladı',
  campaign_viewed: 'kampanyayı görüntüledi',
  campaign_clicked: 'kampanyaya tıkladı',
  limit_increase_requested: 'limit artırma talebinde bulundu',
  limit_increase_approved: 'limit artırma talebi onaylandı',
  limit_increase_rejected: 'limit artırma talebi reddedildi',
  limit_increase_confirmed: 'limit artırma talebi sonuçlandı',
  session_start: 'oturum başlattı',
  session_end: 'oturumunu sonlandırdı',
  session_update: 'oturumunu güncelledi',
  profile_update: 'profil bilgilerini güncelledi',
  customer_rating_submitted: 'uygulamaya puan verdi',
  upcoming_installments_view: 'yaklaşan taksitlerini görüntüledi',
  upcoming_installments_detail_click: 'yaklaşan taksit detayına tıkladı',
  transactions_view_all_click: 'tüm işlemler listesini açtı',
  transactions_filter_apply: 'işlem listesinde filtre uyguladı',
  contact_action_click: 'iletişim seçeneğine tıkladı',
  payment_modal_open: 'ödeme ekranını açtı',
  payment_method_selected: 'ödeme yöntemi seçti',
  sms_verification_result: 'SMS doğrulamasını tamamladı',
  password_set_success: 'yeni şifresini belirledi',
  password_reset_success: 'şifresini sıfırladı',
  qr_code_generated: 'QR kod oluşturdu',
  login_failed: 'başarısız giriş denemesi yaptı',
  onboarding_continue_click: 'yönlendirme adımında devam etti',
  onboarding_step_change: 'yönlendirme adımını değiştirdi',
  onboarding_step_view: 'yönlendirme adımını görüntüledi',
  onboarding_completed: 'yönlendirmeyi tamamladı',
  screen_view: 'sayfa görüntüledi',
  online_payment_started: 'çevrimiçi ödemeyi başlattı',
  online_payment_submitted: 'çevrimiçi ödeme bilgilerini gönderdi',
  online_payment_result: 'çevrimiçi ödeme sonucu aldı',
  sms_resend_click: 'SMS doğrulama kodunu yeniden gönderdi',
  otp_timeout: 'OTP doğrulama süresinin doldu',
  qr_promo_popup_shown: 'QR promosyon penceresini gördü',
  qr_promo_popup_dismissed: 'QR promosyon penceresini kapattı',
  notification_permission_result: 'bildirim izni sonucunu aldı',
  support_lines_open: 'destek hatlarını açtı',
  notification_bell_click: 'bildirim ziline tıkladı',
  web_shopping_closed: 'alışveriş sayfasını kapattı',
  web_shopping_opened: 'alışveriş sayfasını açtı',
  pull_to_refresh: 'listeyi yenilemek için aşağı çekti',
  location_permission_result: 'konum izni sonucunu aldı',
  online_payment_3ds_shown: '3D Secure ödeme ekranını gördü',
  payment_contract_accepted: 'ödeme sözleşmesini onayladı',
  online_payment_3ds_result: '3D Secure ödeme sonucunu aldı',
  limit_increase_offer: 'limit artırma teklifini gördü',
  payment_result_home_click: 'ödeme sonuç ekranından ana sayfaya geçti',
  password_visibility_toggle: 'şifre görünürlüğünü değiştirdi',
  faq_open: 'SSS bölümünü açtı',
  notification_deleted: 'bildirimi sildi',
  password_set_attempt: 'şifre belirleme denemesi yaptı',
  custom_amount_open: 'özel tutar girişini açtı',
  limit_increase_confirm: 'limit artırma talebini onayladı',
  limit_increase_result: 'limit artırma sonucunu aldı',
  transactions_filter_open: 'işlem filtresini açtı',
  receipt_download_click: 'dekont indirmeye tıkladı',
  empty_state_promo_click: 'ekrandaki  "Hemen İncele"  butonuna tıkladı',
  empty_state_view: 'boş liste ekranını görüntüledi',
  empty_state_promo_view: 'boş ekrandaki kampanya tanıtımını görüntüledi',
  screen_dwell: 'ekranda vakit geçirdi',
  notifications_delete_all_confirm: 'tüm bildirimleri silmeyi onayladı',
  notifications_delete_all_open: 'tüm bildirimleri silme ekranını açtı',
  notifications_mark_all_read: 'tüm bildirimleri okundu olarak işaretledi',
  form_validation_error: 'formu hatalı doldurdu',
  upcoming_payments_show_all_click: 'yaklaşan ödemelerinde tümünü gör butonuna tıkladı',
  online_payment_installment_selected: 'çevrimiçi ödemede taksit seçti',
  login_attempt: 'giriş denemesi yaptı',
};

/** İstatistik widget'ı — isim/fiil grubu (örn. "Sayfa görüntülenmesi") */
export const ACTIVITY_EVENT_STAT_LABELS = {
  screen_view: 'Sayfa görüntülenmesi',
  session_start: 'Oturum başlatma',
  session_end: 'Oturum sonlandırma',
  session_update: 'Oturum güncellemesi',
  user_token_registered: 'Bildirim token kaydı',
  user_token_unregistered: 'Bildirim token kaldırıldı',
  user_register: 'Kullanıcı kaydı',
  user_login: 'Uygulama girişi',
  user_logout: 'Uygulama çıkışı',
  user_connection_established: 'WebSocket bağlantısı',
  user_connection_closed: 'WebSocket bağlantısı kapanması',
  notification_sent: 'Bildirim gönderimi',
  notification_read: 'Bildirim okunması',
  notification_click: 'Bildirim tıklaması',
  campaign_viewed: 'Kampanya görüntülenmesi',
  campaign_clicked: 'Kampanya tıklaması',
  limit_increase_requested: 'Limit artırma talebi',
  limit_increase_approved: 'Limit artırma onayı',
  limit_increase_rejected: 'Limit artırma reddi',
  limit_increase_confirmed: 'Limit artırma sonucu',
  payment_success: 'Ödeme başarılı',
  payment_failed: 'Ödeme başarısız',
  payment_initiated: 'Ödeme başlatma',
  payment_modal_open: 'Ödeme ekranı açılması',
  payment_method_selected: 'Ödeme yöntemi seçimi',
  profile_update: 'Profil güncelleme',
  customer_rating_submitted: 'Uygulama değerlendirmesi',
  upcoming_installments_view: 'Yaklaşan taksitler görüntüleme',
  upcoming_installments_detail_click: 'Yaklaşan taksit detayı tıklaması',
  transactions_view_all_click: 'Tüm işlemler listesi açılması',
  transactions_filter_apply: 'İşlem filtresi uygulaması',
  contact_action_click: 'İletişim seçeneği tıklaması',
  login_option_click: 'Giriş seçeneği tıklaması',
  login_failed: 'Başarısız giriş denemesi',
  password_set_success: 'Şifre belirleme',
  password_reset_success: 'Şifre sıfırlama',
  sms_verification_result: 'SMS doğrulama',
  qr_code_generated: 'QR kod oluşturuldu',
  qr_code_generate: 'QR kod oluşturuldu',
  onboarding_continue_click: 'Yönlendirme devam tıklaması',
  onboarding_step_change: 'Yönlendirme adım değişimi',
  onboarding_step_view: 'Yönlendirme adım görüntüleme',
  onboarding_completed: 'Yönlendirme tamamlandı',
  online_payment_started: 'Çevrimiçi ödeme başlatma',
  online_payment_submitted: 'Çevrimiçi ödeme gönderimi',
  online_payment_result: 'Çevrimiçi ödeme sonucu',
  sms_resend_click: 'SMS yeniden gönderme',
  otp_timeout: 'OTP zaman aşımı',
  qr_promo_popup_shown: 'QR promosyon penceresi gösterimi',
  qr_promo_popup_dismissed: 'QR promosyon penceresi kapatma',
  notification_permission_result: 'Bildirim izni sonucu',
  support_lines_open: 'Destek hatları açılması',
  notification_bell_click: 'Bildirim zili tıklaması',
  web_shopping_closed: 'Alışveriş web görünümü kapanması',
  web_shopping_opened: 'Alışveriş web görünümü açılması',
  pull_to_refresh: 'Aşağı çekerek yenileme',
  location_permission_result: 'Konum izni sonucu',
  online_payment_3ds_shown: '3D Secure ekranı gösterimi',
  payment_contract_accepted: 'Ödeme sözleşmesi onayı',
  online_payment_3ds_result: '3D Secure ödeme sonucu',
  limit_increase_offer: 'Limit artırma teklifi',
  payment_result_home_click: 'Ödeme sonucu ana sayfa tıklaması',
  password_visibility_toggle: 'Şifre görünürlüğü değiştirme',
  faq_open: 'SSS açılması',
  notification_deleted: 'Bildirim silme',
  password_set_attempt: 'Şifre belirleme denemesi',
  custom_amount_open: 'Özel tutar girişi açılması',
  limit_increase_confirm: 'Limit artırma onaylama',
  limit_increase_result: 'Limit artırma sonucu',
  transactions_filter_open: 'İşlem filtresi açılması',
  receipt_download_click: 'Dekont indirme tıklaması',
  empty_state_promo_click: 'Boş ekran promosyon tıklaması',
  empty_state_view: 'Boş liste ekranı görüntüleme',
  empty_state_promo_view: 'Boş ekran promosyon görüntüleme',
  screen_dwell: 'Ekranda kalma süresi',
  notifications_delete_all_confirm: 'Tüm bildirimleri silme onayı',
  notifications_delete_all_open: 'Tüm bildirimleri silme ekranı',
  notifications_mark_all_read: 'Tüm bildirimleri okundu işaretleme',
  form_validation_error: 'Form doğrulama hatası',
  upcoming_payments_show_all_click: 'Yaklaşan ödemeler tümünü gösterme',
  online_payment_installment_selected: 'Çevrimiçi ödeme taksit seçimi',
  login_attempt: 'Giriş denemesi',
};

/**
 * Backend snake_case, camelCase veya "Payment Modal Open" gibi başlık gönderir;
 * çeviri tablosu için tek anahtara indirger.
 */
export function normalizeEventTypeKey(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  const s = raw.trim();
  if (!s) return '';

  const slug = s
    .toLocaleLowerCase('tr-TR')
    .normalize('NFKC')
    .replace(/\u0307/g, '')
    .replace(/[^a-z0-9\s_]/g, '')
    .trim()
    .replace(/\s+/g, '_')
    .replace(/_+/g, '_');

  if (!slug) return '';

  const compact = slug.replace(/_/g, '');
  return EVENT_TYPE_ALIASES[slug] || EVENT_TYPE_ALIASES[compact] || slug;
}

export function canonicalEventTypeForDisplay(eventType) {
  return normalizeEventTypeKey(eventType) || eventType;
}

/** Bildirim / konum izni event'lerinde payload status */
export function extractPermissionStatusFromActivityData(activityData) {
  if (!activityData || typeof activityData !== 'object') return '';
  const ev = activityData.eventData || activityData.EventData;
  return String(
    activityData.status ??
      ev?.status ??
      activityData.data?.status ??
      ev?.data?.status ??
      '',
  )
    .trim()
    .toLocaleLowerCase('tr-TR');
}

/** @deprecated — extractPermissionStatusFromActivityData kullanın */
export function extractNotificationPermissionStatus(activityData) {
  return extractPermissionStatusFromActivityData(activityData);
}

/** Anlık aktivite feed — küçük harfli fiil cümlesi */
export function getNotificationPermissionResultPhrase(activityData) {
  const status = extractPermissionStatusFromActivityData(activityData);
  if (status === 'granted') return 'bildirim iznini kabul etti';
  if (status === 'denied') return 'bildirim iznini reddetti';
  if (status === 'provisional') return 'bildirim için geçici (sessiz) izin verdi';
  return ACTIVITY_EVENT_PHRASES.notification_permission_result || 'bildirim izni sonucunu aldı';
}

/** Kullanıcı detay — baş harf büyük */
export function getNotificationPermissionResultTitle(activityData) {
  const phrase = getNotificationPermissionResultPhrase(activityData);
  return phrase.charAt(0).toLocaleUpperCase('tr-TR') + phrase.slice(1);
}

/** location_permission_result — status: full (Android tam izin), denied, granted, provisional */
export function getLocationPermissionResultPhrase(activityData) {
  const status = extractPermissionStatusFromActivityData(activityData);
  if (status === 'denied') return 'konum iznini reddetti';
  if (status === 'granted' || status === 'full') return 'konum iznini kabul etti';
  if (status === 'provisional') return 'konum için geçici izin verdi';
  if (status === 'limited' || status === 'reduced') return 'sınırlı konum izni verdi';
  return ACTIVITY_EVENT_PHRASES.location_permission_result || 'konum izni sonucunu aldı';
}

export function getLocationPermissionResultTitle(activityData) {
  const phrase = getLocationPermissionResultPhrase(activityData);
  return phrase.charAt(0).toLocaleUpperCase('tr-TR') + phrase.slice(1);
}

/**
 * @param {string} eventType
 * @returns {string|null} Türkçe fiil cümlesi veya null (özel işleme bırak)
 */
export function getActivityEventPhrase(eventType) {
  const key = canonicalEventTypeForDisplay(eventType);
  if (!key) return null;
  return ACTIVITY_EVENT_PHRASES[key] || null;
}

/** Başlık formatı (UserDetail vb.) — ilk harf büyük */
export function getActivityEventTitle(eventType) {
  const phrase = getActivityEventPhrase(eventType);
  if (!phrase) return eventType || 'Aktivite';
  return phrase.charAt(0).toLocaleUpperCase('tr-TR') + phrase.slice(1);
}

/** İstatistik widget satır başlığı */
export function getActivityEventStatLabel(eventType) {
  const key = canonicalEventTypeForDisplay(eventType);
  if (key && ACTIVITY_EVENT_STAT_LABELS[key]) {
    return ACTIVITY_EVENT_STAT_LABELS[key];
  }

  const phrase = getActivityEventPhrase(key);
  if (phrase) {
    return phrase.charAt(0).toLocaleUpperCase('tr-TR') + phrase.slice(1);
  }

  if (key && /^[a-z0-9_]+$/.test(key)) {
    return key
      .split('_')
      .filter(Boolean)
      .map((w) => w.charAt(0).toLocaleUpperCase('tr-TR') + w.slice(1))
      .join(' ');
  }

  return eventType || 'Bilinmeyen etkinlik';
}
